export const isValidJSON = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

export const formatJSON = (str: string): string => {
  try {
    return JSON.stringify(JSON.parse(str), null, 2);
  } catch {
    return str;
  }
};

export const getDisplayValue = (value: string | object): string => {
  if (typeof value === "object") {
    return JSON.stringify(value, null, 2);
  }

  // Don't auto-format JSON during display - only format on blur
  return String(value);
};
